import {
  dbItem,
  ModuleTypes,
  ExtendedModuleTypes,
  modsArray2,
  mods2,
} from "../../Shared/sharedInterfaces";
import * as functions from "./sharedFunctions";
import { getModById } from "../Modules/moduleFunctions";
import { kamerItem } from "../../Shared/sharedInterfaces";
import React, { useContext } from "react";
import specialItemConfig from "../config/exceptions/specialItemConfig.json";

import { getModulesFromSavedDb_2, InnerMapValue2 } from "./calculateFunctions";
//import { useSettings } from "../../Navbar/settingsContext";
//const {userSettings } = useSettings();

const MAX_MODS = 150;
//const MAX_ADDR = Number(sessionStorage.getItem("maxadres"));
//const MAX_ADDR = userSettings?.maxadres || 388;

//import {mods2, modsArray2} from "./../../Shared/sharedInterfaces"
// Get outputs from woningtree an calculate offerte/kast items
interface modToAdd {
  count: number;
  iMapKey: string;
  valueKey: string;
  outputs: dbItem[];
}

interface InnerMapValue {
  used: number;
  vrij: number;
  modType: string;
  modId: number;
  usedadresses: number;
  outputs: dbItem[];
  kastId: string;
}

interface MapEntry {
  key: string;
  value: Map<string, InnerMapValue>;
}

function calculateModules(
  moduleType: string,
  aantal: number,
  onlySa: boolean,
  rel04_08: boolean,
  kastId: string,
) {
  if (
    moduleType === "ROL" ||
    moduleType === "hand" ||
    moduleType === "fan" ||
    moduleType === "stopc"
  ) {
    moduleType = "REL";
  }
  const module = functions.getModule(moduleType, onlySa);

  const moduleParameters = module.retModules;
  function createNestedMap(): Map<string, InnerMapValue> {
    return new Map();
  }
  let modulesMap = createNestedMap();

  let outp = {};

  let modulesO: Array<{
    outputs: number;
    type: string;
    counter: number;
    vrij: number;
    modType: string;
    modId: number;
    adresses: number;
    usedadresses: number;
    //kastId: string;
    //totBusCons: number,
    //busc: number,
  }> = [];
  // moduleType: REL
  moduleParameters.forEach((mod) => {
    // if (rel04_08 === true) //Enkel REL04SA
    //debugger
    if (moduleType === "REL") {
      if (rel04_08 === false) {
        let modi = {
          outputs: mod.outputs,
          type: mod.name,
          counter: 0,
          vrij: 0,
          modType: moduleType,
          modId: mod.id,
          adresses: mod.adresses,
          usedadresses: 0,
          kastId: kastId,
          //totBusCons: 0,
          // busc: mod.busConsumption
        };
        modulesO.push(modi);
      } else {
        if (mod.name === "REL04SA") {
          let modi = {
            outputs: mod.outputs,
            type: mod.name,
            counter: 0,
            vrij: 0,
            modType: moduleType,
            modId: mod.id,
            adresses: mod.adresses,
            usedadresses: 0,
            kastId: kastId,
            // totBusCons: 0,
            // busc: mod.busConsumption
          };
          modulesO.push(modi);
        }
      }
    } else {
      //&& rel04_08 === false) {
      let modi = {
        outputs: mod.outputs,
        type: mod.name,
        counter: 0,
        vrij: 0,
        modType: moduleType,
        modId: mod.id,
        adresses: mod.adresses,
        usedadresses: 0,
        //kastId: kastId
        // totBusCons: 0,
        // busc: mod.busConsumption
      };
      modulesO.push(modi);
    }
  });

  let modc = Object.keys(modulesO).length;

  let newo = aantal;
  //vrij = 0

  // modc - Aantal modules voor dit type
  // modulesO - Array van modules voor dit ype
  // counter, modId, modType, outputs, type, vrij
  // Here we update the counters for each modulesO
  // ToDo:

  for (let i = 0; i < modc; i++) {
    //debugger
    let currOutputs = modulesO[i].outputs;
    let nextOutputs = 0;
    //debugger
    // First mod
    if (i < modc - 1) {
      nextOutputs = modulesO[i + 1].outputs;
    }
    //debugger
    let teller1 = Math.floor(newo / currOutputs);
    let oversc = newo - teller1 * currOutputs;

    if (i === 0 && teller1 >= 1 && oversc !== 0) {
      modulesO[i].counter = teller1;
      modulesO[i].vrij = 0;
      modulesO[i].usedadresses =
        modulesO[i].counter * modulesO[i].outputs * modulesO[i].adresses -
        modulesO[i].vrij * modulesO[i].adresses;
      //modulesO[i].totBusCons = (modulesO[i].counter * )
      // modulesO[i].totBusCons = modulesO[i].busc * modulesO[i].counter
    }

    if (oversc < currOutputs && oversc > nextOutputs) {
      modulesO[i].counter++;
      modulesO[i].vrij = currOutputs - oversc;
      modulesO[i].usedadresses =
        modulesO[i].counter * modulesO[i].outputs * modulesO[i].adresses -
        modulesO[i].vrij * modulesO[i].adresses;
      //modulesO[i].totBusCons = modulesO[i].busc * modulesO[i].counter
      //modulesO[i].totoutp = modulesO[i].totoutp
      break;
    } else if (oversc === currOutputs) {
      modulesO[i].counter++;
      modulesO[i].vrij = currOutputs - oversc;
      modulesO[i].usedadresses =
        modulesO[i].counter * modulesO[i].outputs * modulesO[i].adresses -
        modulesO[i].vrij * modulesO[i].adresses;
      //modulesO[i].totBusCons = modulesO[i].busc * modulesO[i].counter
    }

    if (i === 0 && oversc === 0) {
      modulesO[i].counter = Math.floor(aantal / currOutputs);
      modulesO[i].vrij = 0;
      modulesO[i].usedadresses =
        modulesO[i].counter * modulesO[i].outputs * modulesO[i].adresses -
        modulesO[i].vrij * modulesO[i].adresses;
      //modulesO[i].totBusCons = modulesO[i].busc * modulesO[i].counter
      break;
    } else if (oversc === 0) {
      modulesO[i].counter++;
      modulesO[i].vrij = 0;
      //modulesO[i].totoutp = currOutputs
      modulesO[i].usedadresses =
        modulesO[i].counter * modulesO[i].outputs * modulesO[i].adresses -
        modulesO[i].vrij * modulesO[i].adresses;
      //modulesO[i].totBusCons = modulesO[i].busc * modulesO[i].counter
      break;
    }
  }

  modulesO.forEach((mod) => {
    if (mod.counter > 0) {
      let outp: InnerMapValue = {
        used: mod.counter,
        vrij: mod.vrij,
        modType: mod.modType,
        modId: mod.modId,
        usedadresses: mod.usedadresses,
        outputs: [],
        kastId: kastId,
        // usedBusConsumption: mod.totBusCons
      };
      modulesMap.set(mod.type, outp);
    }
  });
  return modulesMap;
}

function calculateModulesFromMods2(
  moduleType: string,
  aantal: number,
  kastId: string,
  items: dbItem[],
) {
  // Here is aantal - aantal adressen - should be aantal modules
  function createNestedMap(): Map<string, InnerMapValue> {
    return new Map();
  }

  let modulesMap = createNestedMap();

  function getModulePage(
    data: dbItem[],
    page: number,
    moduletype: string,
    modCounter: number,
  ) {
    // page is 1-based (1 = first 4 items, 2 = next 4, ...)
    const filtered = data.filter(
      (item) => item.outputOptions.moduletype === moduletype,
    );

    const start = (page - 1) * modCounter;
    const end = start + modCounter;

    return filtered.slice(start, end);
  }

  let counter = 1;
  let mods = [];
  for (let i = 0; i < aantal; i++) {
    let modToAdd = {} as modToAdd;
    const mod = functions.getModuleFromName(moduleType ?? "");

    modToAdd.valueKey = moduleType;
    if (mod) {
      const outputs = getModulePage(items, counter, moduleType, mod.outputs);
      modToAdd.iMapKey = mod.type;
      const maxOutp = mod.outputs;
      modToAdd.count = Math.ceil(counter / maxOutp); // Round up otherwise we could have 0.75 modules
      modToAdd.outputs = outputs;
      counter = counter + 1;
    }
    mods.push(modToAdd);
  }
  const nestedMap: Map<string, Map<string, InnerMapValue>> = new Map();
  //const nestedMap = iMap;

  function createInnerValue(
    modType: string,
    count: number,
    outputs: dbItem[],
    kastId: string,
  ): InnerMapValue {
    return {
      used: count,
      vrij: 0,
      modType,
      modId: Date.now(),
      usedadresses: count,
      outputs: outputs,
      kastId: kastId,
    };
  }

  for (const mod of mods) {
    const { iMapKey, valueKey, count, outputs } = mod;
    if (!iMapKey || !valueKey) continue;

    let innerMap = nestedMap.get(iMapKey);
    if (!innerMap) {
      innerMap = new Map<string, InnerMapValue>();
      nestedMap.set(iMapKey, innerMap);
    }

    const existing = innerMap.get(valueKey);
    if (existing) {
      existing.used += count;
    } else {
      modulesMap.set(
        valueKey,
        createInnerValue(iMapKey, count, outputs, kastId),
      );
    }
  }

  return modulesMap;
}

// komt van overzicht.tsx
// Can we delete this ???????????
export function getModules(arr: kamerItem, onlySa: boolean, rel04_08: boolean) {
  //console.log("OVERZICHT ARR: ", arr)
  //console.log(arr)
  // returns a map:
  // //[key: "REL", value(map): [{key: REL02SA, value: 1} , {key:REL01SA, value: 1}]]

  let modulesMap = new Map<string, number>();

  const test = (item: kamerItem) => {
    item.children?.forEach((item) => {
      let currentCounter: number = 0;
      let newCounter: number = 0;
      //item.icon.key = database value module type (REL, DIM)
      if (React.isValidElement(item.icon)) {
        if (item.icon.key !== "woning") {
          if (item.icon.key) {
            let treeiconkey = item.icon.key;

            if (
              treeiconkey === "ROL" ||
              treeiconkey === "hand" ||
              treeiconkey === "fan" ||
              treeiconkey === "stopc"
            ) {
              treeiconkey = "REL";
            }
            //console.log(item)
            //debugger
            // RELROL !!!!!!!!!!

            // item.icon.key = REL, DIM
            currentCounter = modulesMap.get(treeiconkey)!;
            newCounter = currentCounter + 1;

            if (newCounter) {
              modulesMap.set(treeiconkey, newCounter);
            } else {
              modulesMap.set(treeiconkey, 1);
            }
          }
        }
      }

      if (item.children) {
        //console.log(item.children?.length)

        if (item.children?.length >> 0) {
          test(item);
        }
      }
    });
  };

  test(arr);

  //console.log
  //console.log("MODMAP: ", modulesMap)
  // [{REL: 3}, ...]

  let iMap = new Map<string, object>();
  modulesMap.forEach((value, key) => {
    //console.log(key, value)
    //console.log (typeof(calculateModules(key, value)))
    // key = REL, DIM, ...
    // value = {REL04SA, 2}
    iMap.set(key, calculateModules(key, value, onlySa, rel04_08, "kast-a"));
  });

  return iMap;
}

function getExtMod(id: number) {
  // Find module in Extended database
  const dbExtendedMods: ExtendedModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbExtendedModuleTypes") || "{}",
  );

  let retmod = {};
  dbExtendedMods.forEach((mod: ExtendedModuleTypes) => {
    if (mod.module_id === id) {
      retmod = mod;
    }
  });
  return retmod;
}

function findModId(type: string) {
  const dbMods: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );
  let retMod = {};

  if (dbMods) {
    dbMods.forEach((mod: ModuleTypes) => {
      if (mod.name === type) {
        const modret = getExtMod(mod.id);
        retMod = modret;
      }
    });
  }
  return retMod;
}

export function getModuleParameters(type: string) {
  const dbMods: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );
  // Find module in modules database

  let rMod = {
    busConsumption: 0,
    parentModule: 0,
    offCat: 0,
    adresses: 0,
    sa: 0,
    pakket: 0,
    prijs: 0,
  };

  if (dbMods) {
    dbMods.forEach((mod: ModuleTypes) => {
      if (mod.name === type) {
        rMod.busConsumption = mod.busConsumption;
        rMod.parentModule = mod.parentModule;
        rMod.offCat = mod.offCat;
        rMod.adresses = mod.adresses;
        rMod.sa = mod.sa;
        rMod.pakket = mod.pakket;
        rMod.prijs = mod.prijs;
      }
    });
  }
  return rMod;
}

export function getModuleParametersByType(type: string) {
  const dbMods: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );
  // Find module in modules database
  //console.log("DBMods: ", dbMods)
  //let retMod = 0;

  let rMod = {
    busConsumption: 0,
    parentModule: 0,
    offCat: 0,
    adresses: 0,
    sa: 0,
    pakket: 0,
  };

  if (dbMods) {
    dbMods.forEach((mod: ModuleTypes) => {
      if (mod.type === type) {
        //const buscons = mod.busConsumption;
        //retMod = buscons;
        rMod.busConsumption = mod.busConsumption;
        rMod.parentModule = mod.parentModule;
        rMod.offCat = mod.offCat;
        rMod.adresses = mod.adresses;
        rMod.sa = mod.sa;
        rMod.pakket = mod.pakket;
      }
    });
  }
  //console.log ("findmod/ ", rMod)
  return rMod;
}

export function getModuleParametersByID(id: number) {
  const dbMods: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );
  // Find module in modules database
  //console.log("DBMods: ", dbMods)
  //let retMod = 0;

  let rMod = {
    busConsumption: 0,
    //parentModule: 0,
    //offCat: 0,
    //adresses: 0,
    //sa: 0,
    //pakket: 0,
  };

  if (dbMods) {
    dbMods.forEach((mod: ModuleTypes) => {
      if (mod.id === id) {
        //const buscons = mod.busConsumption;
        //retMod = buscons;
        rMod.busConsumption = mod.busConsumption;
        //rMod.parentModule = mod.parentModule;
        // rMod.offCat = mod.offCat;
        //rMod.adresses = mod.adresses;
        // rMod.sa = mod.sa;
        //rMod.pakket = mod.pakket;
      }
    });
  }
  //console.log ("findmod/ ", rMod)
  return rMod;
}

function getCtds() {
  const dbMods: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );
  let ctds = [{}];

  if (dbMods) {
    dbMods.forEach((mod: ModuleTypes) => {
      if (mod.name.includes("CTD")) {
        ctds.push(mod);
      }
    });
  }
  return ctds;
}

function getExpantion() {
  const dbMods: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );
  // Find module in modules database
  //console.log("DBMods: ", dbMods)
  let exp = {};

  if (dbMods) {
    dbMods.forEach((mod: ModuleTypes) => {
      if (mod.name.includes("EXP15")) {
        //const buscons = mod.busConsumption
        exp = mod;
      }
    });
  }
  // console.log ("findmod/ ", retMod)
  return exp;
}

//This functions calculates the controller(s) we need
function addCtds(
  modCounter: number,
  ctds = [{}],
  added_ctd1: dbItem,
  counter: number,
) {
  const retCtd2: dbItem = structuredClone(added_ctd1);

  /*
    For each ctd we get:
      * modCounter: # modules on this ctd
      * adresCounter: # adresses in use on this ctd
      * busconsumtion: # buscon for this ctd
    
    For the moment we only check on modules.
    * modCounter < 11 -> CTD10
    * modCounter > 11 && < 26 -> CTD10 + exp
    * modCounter > 26 && < 41 -> CTD40
    * modCounter > 41 && < 56 -> CTD40 + exp
    * modCounter > 56 && < 150 -> CTDMax
    * modCounter > 150 -> CTDMax + extra
    
    We could have a module (like dmx) that can use a lot of adresses
    If adresses are > 396 we need a second controller

    We also have modules that have a high busconsumtion
    Max current for CTDx is 2.000 mA. If we go above this -> extra controller
    
  */

  if (added_ctd1) {
    // added_ctd - ctd added by user
    let retCtd: any = {};
    let expantion = false;
    let retmodcounter = 0;

    // CTD10
    if (modCounter < 11) {
      ctds.forEach((m: any) => {
        if (m.name === "CTD10") {
          retCtd = m;
        }
      });
      const modulesOver = 10 - modCounter;
      if (modulesOver > 0) {
        retCtd.vrij = modulesOver;
      } else {
        retCtd.vrij = 0;
      }

      retCtd2.outputOptions.moduletype = "CTD10";

      if (counter >> 0) {
        retCtd2.outputOptions.ctdId =
          added_ctd1.outputOptions.ctdId + counter * 100;
        retCtd2.nodeid = "ctd-" + retCtd2.outputOptions.ctdId;
      }

      retmodcounter = 0;
      expantion = false;
    } else if (modCounter < 26) {
      //ctd = "CTD10 + exp";
      ctds.forEach((m: any) => {
        if (m.name === "CTD10") {
          retCtd = m;
        }
      });
      const modulesOver = 25 - modCounter;
      if (modulesOver > 0) {
        retCtd.vrij = modulesOver;
      } else {
        retCtd.vrij = 0;
      }

      retCtd2.outputOptions.moduletype = "CTD10";

      if (counter >> 0) {
        retCtd2.outputOptions.ctdId =
          added_ctd1.outputOptions.ctdId + counter * 100;
        retCtd2.nodeid = "ctd-" + retCtd2.outputOptions.ctdId;
      }

      expantion = true;
      retmodcounter = 0;
    } else if (modCounter < 41) {
      //ctd = "CTD40";
      ctds.forEach((m: any) => {
        if (m.name === "CTD40") {
          retCtd = m;
        }
      });
      const modulesOver = 40 - modCounter;
      if (modulesOver > 0) {
        retCtd.vrij = modulesOver;
      } else {
        retCtd.vrij = 0;
      }

      // Change added CTD to CTD40
      retCtd2.outputOptions.moduletype = "CTD40";
      retCtd2.label = "CTD40";
      if (counter >> 0) {
        retCtd2.outputOptions.ctdId =
          added_ctd1.outputOptions.ctdId + counter * 100;
        retCtd2.nodeid = "ctd-" + retCtd2.outputOptions.ctdId;
      }
      // }

      expantion = false;
    } else if (modCounter < 56) {
      //ctd = "CTD40";
      ctds.forEach((m: any) => {
        if (m.name === "CTD40") {
          retCtd = m;
        }
      });
      const modulesOver = 55 - modCounter;
      if (modulesOver > 0) {
        retCtd.vrij = modulesOver;
      } else {
        retCtd.vrij = 0;
      }

      // Change added CTD to CTD40
      retCtd2.outputOptions.moduletype = "CTD40";
      retCtd2.label = "CTD40";
      // }
      if (counter >> 0) {
        retCtd2.outputOptions.ctdId =
          added_ctd1.outputOptions.ctdId + counter * 100;
        retCtd2.nodeid = "ctd-" + retCtd2.outputOptions.ctdId;
      }

      expantion = true;
      retmodcounter = 0;
    } else if (modCounter >= 56 && modCounter <= 150) {
      //ctd = "CTDmax";
      ctds.forEach((m: any) => {
        if (m.name === "CTDmax") {
          retCtd = m;
        }
      });
      const modulesOver = 150 - modCounter;

      if (modulesOver > 0) {
        retCtd.vrij = modulesOver;
      } else {
        retCtd.vrij = 0;
      }

      // Change added CTD to CTD40
      retCtd2.outputOptions.moduletype = "CTDmax";
      retCtd2.label = "CTDmax";

      if (counter >> 0) {
        retCtd2.outputOptions.ctdId =
          added_ctd1.outputOptions.ctdId + counter * 100;
        retCtd2.nodeid = "ctd-" + retCtd2.outputOptions.ctdId;
      }

      expantion = false;
    } else if (modCounter > 150) {
      //ctd = "CTDmax";
      ctds.forEach((m: any) => {
        if (m.name === "CTDmax") {
          retCtd = m;
        }
      });
      expantion = false;
      retmodcounter = modCounter - 150;
      const modulesOver = 150 * Math.ceil(modCounter / 150) - modCounter;

      // Change added CTD to CTDmax
      retCtd2.outputOptions.moduletype = "CTDmax";
      retCtd2.label = "CTDmax";

      if (counter >> 0) {
        retCtd2.outputOptions.ctdId =
          added_ctd1.outputOptions.ctdId + counter * 100;
        retCtd2.nodeid = "ctd-" + retCtd2.outputOptions.ctdId;
      }

      if (modulesOver > 0) {
        retCtd.vrij = modulesOver;
      } else {
        retCtd.vrij = 0;
      }
      if (modulesOver >= 56 && modulesOver <= 150) {
        retCtd.vrij = 0;
      }

      if (retmodcounter < 0) {
        retmodcounter = 0;
      }
    }

    const ret = {
      ctd: retCtd,
      expantion: expantion,
      retmodcounter: retmodcounter,
    };
    return { ret, retCtd2 };
  } else {
    const ret = {
      ctd: "",
      expantion: false,
      retmodcounter: 0,
    };
    return { ret, retCtd2 };
  }
}

function addCtdsToMods(
  modCounter: number,
  modules: modsArray2,
  retCtd: any,
  expantion: boolean,
) {
  const exp: any = getExpantion();
  if (modCounter >> 0) {
    modules.mods.push({
      module: retCtd.name,
      aantal: 1,
      prijs: retCtd.prijs,
      vrij: retCtd.vrij,
      modType: "CTD",
      busCons: 0,
      parentModule: 0,
      modId: retCtd.id,
      offCat: retCtd.offCat,
      adresses: 0,
      sa: 0,
      pakket: 0,
      totadres: 0,
    });
  }

  if (expantion === true) {
    modules.mods.push({
      module: exp.name,
      aantal: 1,
      prijs: exp.prijs,
      vrij: 0,
      modType: "EXP",
      busCons: 0,
      parentModule: 0,
      modId: exp.id,
      offCat: exp.offCat,
      adresses: 0,
      sa: 0,
      pakket: 0,
      totadres: 0,
    });
  }

  return modules;
}
interface ControllerData {
  label: string;
  values: Map<string, number>;
}

function setMapValues(
  controllersMap: Map<number, ControllerData>,
  ctdId: number,
  buscons: number,
  adresses: number,
  mods: number,
): Map<number, ControllerData> {
  const controller = controllersMap.get(ctdId);
  if (!controller) return controllersMap;

  const vals = controller.values;
  vals.set("buscons", (vals.get("buscons") ?? 0) + buscons);
  vals.set("adresses", (vals.get("adresses") ?? 0) + adresses);
  vals.set("mods", (vals.get("mods") ?? 0) + mods);

  return controllersMap;
}

function buildControllersMap(
  controllersMap: Map<number, ControllerData>,
  controllers: dbItem[],
  modules: modsArray2,
  skipArray: number[],
  maxdres: number,
): Map<number, ControllerData> {
  const controllerIds = controllers.map((c) => c.outputOptions.ctdId);
  let controllerIndex = 0;
  let slotsUsedOnCurrent =
    controllersMap.get(controllerIds[0])?.values.get("mods") ?? 0;
  let addrUsedOnCurrent =
    controllersMap.get(controllerIds[0])?.values.get("adresses") ?? 0;
  let outOfControllers = false;

  let controllerIndex2 = 0;

  for (const ctd of controllers) {
    controllerIndex2 = ctd.outputOptions.ctdId;

    if (
      controllerIndex2 < 100 &&
      !skipArray.includes(ctd.outputOptions.ctdId)
    ) {
      for (const mod of modules.mods.filter(
        (m) =>
          m.modType !== "CTD" &&
          m.modType !== "EXP" &&
          m.busCons !== -1 &&
          m.ctdId === controllerIndex2,
      )) {
        if (outOfControllers) break;
        let remaining = mod.aantal ?? 1;
        const addrPerUnit = mod.adresses ?? 0;
        const shouldCountAsMod =
          mod.parentModule === 0 || mod.parentModule == null;

        while (remaining > 0) {
          // Advance if either limit is hit

          if (slotsUsedOnCurrent >= MAX_MODS || addrUsedOnCurrent >= maxdres) {
            controllerIndex++;
            if (controllerIndex < controllerIds.length) {
              const nextCtdId = controllerIds[controllerIndex];
              slotsUsedOnCurrent =
                controllersMap.get(nextCtdId)?.values.get("mods") ?? 0;
              addrUsedOnCurrent =
                controllersMap.get(nextCtdId)?.values.get("adresses") ?? 0;
            }
          }

          if (controllerIndex >= controllerIds.length) {
            console.warn("Not enough controllers for all modules");
            outOfControllers = true;
            break;
          }

          const ctdId = controllerIds[controllerIndex];

          // How many fit based on both limits
          const availableByMods = shouldCountAsMod
            ? MAX_MODS - slotsUsedOnCurrent
            : remaining;
          const availableByAddr =
            addrPerUnit > 0
              ? Math.floor((maxdres - addrUsedOnCurrent) / addrPerUnit)
              : remaining;

          const toPlace = Math.min(remaining, availableByMods, availableByAddr);

          if (toPlace <= 0) {
            // Can't fit even 1 unit — advance controller
            controllerIndex++;
            slotsUsedOnCurrent = 0;
            addrUsedOnCurrent = 0;
            continue;
          }

          setMapValues(
            controllersMap,
            ctdId,
            (mod.busCons ?? 0) * toPlace,
            addrPerUnit * toPlace,
            shouldCountAsMod ? toPlace : 0,
          );

          slotsUsedOnCurrent += shouldCountAsMod ? toPlace : 0;
          addrUsedOnCurrent += addrPerUnit * toPlace;
          remaining -= toPlace;
        }
      }
    } else {
      if (controllerIndex2 > 100) {
        controllerIndex++;
      }
    }
  }

  return controllersMap;
}
function CalculateAddrModBusc(
  modules: modsArray2,
  controllers: dbItem[],
  maxdres: number,
) {
  let controllersMap = new Map<number, ControllerData>(
    controllers.map((c) => [
      c.outputOptions.ctdId,
      {
        label: c.label,
        nodeId: c.nodeid,
        values: new Map<string, number>([
          ["buscons", 0],
          ["adresses", 0],
          ["mods", 0],
        ]),
      },
    ]),
  );

  let ctdArray: number[] = [];
  controllers.forEach((controller) => {
    controllersMap.set(controller.outputOptions.ctdId, {
      label: controller.label,
      values: new Map(),
    });
    ctdArray.push(controller.outputOptions.ctdId);

    //controllersMap.get(controller.outputOptions.ctdId)?.set("label", controller.label);
  });

  const c2 = ctdArray.filter((n) => n >= 100).length;

  const result = ctdArray.filter((item) => item - 100 > 0); // items > 100 (should be upgraded)
  const result2 = ctdArray
    .filter((item) => item - 100 > 0)
    .map((item) => item - 100); // niet upgraden, dit moet al een max zijn door modules ->

  // only ctds that did not update for modules
  const result3 = ctdArray.filter(
    (item) => item <= 100 && !result2.includes(item),
  ); // deze hebben nog geen upgrade

  if (c2 === 0) {
    const mods = modules.mods;
    mods.forEach((module: mods2) => {
      if (
        module.modType !== "CTD" &&
        module.modType !== "EXP" &&
        module.busCons !== -1
      ) {
        const ctdId = module.ctdId || 0;
        const totadresses = module.totadres || 0;
        const shouldCountAsMod =
          module.parentModule === 0 || module.parentModule == null;

        const totBusv = module.busCons;
        const aantalMods = module.aantal;
        const totModBusCons = aantalMods * totBusv!;

        const prevBuscons: number =
          controllersMap.get(ctdId)?.values.get("buscons") || 0;

        const prevadresses: number =
          controllersMap.get(ctdId)?.values.get("adresses") || 0;

        const prevMods: number =
          controllersMap.get(ctdId)?.values.get("mods") || 0;
        /*
        setMapValues(
          controllersMap,
          ctdId,
          prevBuscons + totModBusCons,
          prevadresses + totadresses,
          prevMods + aantalMods,
        );
*/
        setMapValues(
          controllersMap,
          ctdId,
          totModBusCons,
          totadresses,
          shouldCountAsMod ? aantalMods : 0,
        );
      }
    });
  } else {
    // bij mods en extra controller komen we hier - bij adressen niet
    // result3 -> ctd's die later geupdated worden met adressen
    result3.forEach((ctdIDS) => {
      const mods = modules.mods;
      mods.forEach((module: mods2) => {
        if (
          module.modType !== "CTD" &&
          module.modType !== "EXP" &&
          module.busCons !== -1 &&
          module.ctdId === ctdIDS
        ) {
          const ctdId = module.ctdId;
          const totadresses = module.totadres || 0;
          const shouldCountAsMod =
            module.parentModule === 0 || module.parentModule == null;

          const totBusv = module.busCons;
          const aantalMods = module.aantal;
          const totModBusCons = aantalMods * totBusv!;

          setMapValues(
            controllersMap,
            ctdId,
            totModBusCons,
            totadresses,
            shouldCountAsMod ? aantalMods : 0,
          );
        }
      });
    });
    // Start adding values to first controller.
    // If modCounter > 150 -> set second

    controllersMap = buildControllersMap(
      controllersMap,
      controllers,
      modules,
      result3,
      maxdres,
    );
  }

  return controllersMap;
}
function addCtdXToMods(ctdType: string, key: number, modules: modsArray2) {
  const retCtd = functions.getModuleFromName(ctdType);

  if (retCtd) {
    modules.mods.push({
      module: retCtd.name,
      aantal: 1,
      prijs: retCtd.prijs,
      vrij: 0,
      modType: "CTD",
      busCons: 0,
      parentModule: key,
      modId: retCtd.id,
      offCat: retCtd.offCat,
      adresses: 0,
      sa: 0,
      pakket: 0,
      totadres: 0,
    });
  }

  return modules;
}
function CalcultateCtd(
  modules: modsArray2,
  controllers2: dbItem[],
  maxadres: number,
) {
  const mods = modules.mods;
  let added_ctd: dbItem[] = [];
  const controllers = controllers2
    .filter((item) => item.type === "controller")
    .map((item) => ({ ...item }));

  const ctds = getCtds();

  // Upgrade - Add controller by addresses
  controllers.forEach((controller) => {
    let modCounter = 0;
    let ctdId = controller.outputOptions.ctdId;

    mods.forEach((m: any) => {
      if (m.busCons >> 0 && m.ctdId === ctdId) {
        modCounter = modCounter + m.aantal;
      }
    });

    const { ret, retCtd2 } = addCtds(modCounter, ctds, controller, 0);

    added_ctd.push(structuredClone(retCtd2));

    let retCtd: any = ret.ctd;
    let expantion = ret.expantion;
    let retmodcounter = ret.retmodcounter;

    modules = addCtdsToMods(modCounter, modules, retCtd, expantion);

    if (modCounter > 0) {
      let x = 1;

      // Normally retmodcounter can only be bigger that 0 if ret ctd is max
      while (retmodcounter !== 0) {
        //while (retmodcounter !== 0 || ctdCounter << ctdCalculation) {
        // if (retmodcounter === 0) {
        // retmodcounter can only be 0 here if we need an extra controller
        // because be can't use all adresses / busconsumtion we need
        // so we can add a CTD10 here
        // } else {
        // Todo check if ctd is in array, if so: change counter for offerte

        const { ret, retCtd2 } = addCtds(retmodcounter, ctds, controller, x);
        x++;

        let multic: boolean = false;

        modules.mods.forEach((m: any) => {
          if (
            m.modType === "CTD" &&
            m.module === ret.ctd.name &&
            retmodcounter !== 0
          ) {
            // Als we al een CTD van dit type hebben -> +1
            console.log("z");

            m.aantal++;
            retmodcounter = ret.retmodcounter;
            multic = true;
          } else if (
            m.modType === "CTD" &&
            m.module !== ret.ctd.name &&
            retmodcounter !== 0
          ) {
            // Anders voeg ctd toe
            retmodcounter = ret.retmodcounter;

            multic = false;
            // If we have a CTDMAX and need a second controller:
            retCtd = ret.ctd;
            expantion = ret.expantion;
            retmodcounter = ret.retmodcounter;

            modules = addCtdsToMods(modCounter, modules, retCtd, expantion);

            added_ctd.push(structuredClone(retCtd2));

            // Here we have another ctd
            //ctdCounter++;
          }
        });
      }
    }
  });

  // Here we return modules and ctd's
  const calctd: Map<number, ControllerData> = CalculateAddrModBusc(
    modules,
    added_ctd,
    maxadres,
  );
  

  function addCtd(
    arr: dbItem[],
    {
      ctdId,
      kastId,
      moduletype,
      parent,
      nodeIndex, // used for nodeid
      label,
    }: {
      ctdId: number;
      kastId: number;
      moduletype: string;
      parent: string;
      nodeIndex: number;
      label: string;
    },
  ): dbItem[] {
    const newNode: dbItem = {
      label: label,
      nodeid: `ctd-${ctdId}`,
      parent,
      type: "controller",
      typeIcon: "",
      outputOptions: {
        dmxType: "0",
        ctdId,
        kastId,
        moduletype,
      },
    };

    return [...arr, newNode];
  }
  let updated: dbItem[] = controllers;
  //debugger;
  // hier maken we een extra debuggerctd voor addressen

  [...calctd.entries()].forEach(([key, value]) => {
    // calctd.forEach((value, key) => {
    // for adresses we have only 1 ctd
    // for modules we could have more, but all calculations are done on ctd1
    // console.log("==============================================");
    //console.log("Calc ", key);
    //console.log("==============================================");

    const adresCounter: number = value.values.get("adresses") || 0;
    const busconsumtion: number = value.values.get("buscons") || 0;
    const busConsCtdCalculation = Math.ceil(busconsumtion / 2000);

    const vrijeadressen = maxadres - adresCounter;
    const modsCounter: number = value.values.get("mods") || 0;
    const aantalCtdsNodig = Math.max(
      Math.ceil(adresCounter / maxadres),
      Math.ceil(modsCounter / MAX_MODS),
    );
    //    console.log("ctdId: ", key);
    //    console.log("Aantal vrije adressen: ", vrijeadressen);
    //    console.log("Aantal ctds nodig: ", aantalCtdsNodig);
    //console.log({ key, adresCounter, aantalCtdsNodig });
    // IF vrijeadressen < 50 -> Extra ctd geadviseerd

    type ModDistribution = { ctdId: number; aantal: number; totadres: number };

    const needsRedistribution =
      adresCounter > maxadres || modsCounter > MAX_MODS;
    //const needsRedistribution = adresCounter > MAX_ADDR ;//|| modsCounter > MAX_MODS;

    //Fout als modsCounter > MAX_MODS
    if (needsRedistribution) {
      console.log("needsRedistribution - adresCounter: ", adresCounter);
      console.log("needsRedistribution - modsCounter: ", modsCounter);

      const filtered = mods
        .filter((obj) => obj.ctdId === key)
        .sort((a, b) => (b.adresses ?? 0) - (a.adresses ?? 0));

      const match = controllers.find((o) => o.outputOptions.ctdId === key);
      const kastId = match?.outputOptions?.kastId ?? 1;
      const parent = match?.parent || "1";
      const label = match?.label || "CTD10";

      const maxCtdId = controllers.length
        ? Math.max(...controllers.map((o) => o.outputOptions.ctdId))
        : 0;

      const ctdSlots: {
        ctdId: number;
        usedadresses: number;
        usedMods: number;
      }[] = [{ ctdId: key, usedadresses: 0, usedMods: 0 }];

      const moduleDistribution = new Map<number, ModDistribution[]>();

      filtered.forEach((mod) => {
        const busTypeKey =
          (mod.modType || "").toLowerCase() as keyof typeof specialItemConfig;
        const isSpecialBus = Boolean(specialItemConfig[busTypeKey]);
        const adressesPerUnit = mod.adresses ?? 0;
        // adresCOUNTER
        //const adressesPerUnit = ((mod.totadres! / mod.adresses!) + mod.vrij) / mod.aantal
        // debugger
        let unitsLeft = mod.aantal;

        if (!moduleDistribution.has(mod.modId!)) {
          moduleDistribution.set(mod.modId!, []);
        }

        while (unitsLeft > 0) {
          let targetSlot = ctdSlots.find(
            (slot) =>
              (isSpecialBus || slot.usedadresses + adressesPerUnit <= maxadres) &&
              slot.usedMods < MAX_MODS,
          );
          //debugger

          if (!targetSlot) {
            const newCtdId = key + ctdSlots.length * 100;
            const newSlot = { ctdId: newCtdId, usedadresses: 0, usedMods: 0 };
            ctdSlots.push(newSlot);
            targetSlot = newSlot;

            updated = addCtd(controllers, {
              ctdId: newCtdId,
              kastId: kastId,
              moduletype: "CTD10",
              parent: parent,
              nodeIndex: maxCtdId + ctdSlots.length - 1,
              label: label + "/" + (ctdSlots.length - 1),
            });

            calctd.set(newCtdId, {
              label: label + "/" + (ctdSlots.length - 1),
              values: new Map<string, number>([
                ["buscons", 0],
                ["adresses", 0],
                ["mods", 0],
              ]),
            });

            const alreadyAdded = modules.mods.find(
              (m) => m.parentModule === newCtdId,
            );
            //debugger
            if (!alreadyAdded) {
              // Diabled 31/3
              /**
               * TODO Hier klopt nog iets niet
               * Ene keer goed voor mod en andere keer voor ctd
               * Probleem is dat voor veel
               */
              //debugger
              if (modsCounter > MAX_MODS || adresCounter > maxadres) {
                modules = addCtdXToMods("CTD10", newCtdId, modules);
              }
              //
            }
          }

          const unitsFitByAddr =
            isSpecialBus
              ? unitsLeft
              : adressesPerUnit > 0
              ? Math.floor(
                  (maxadres - targetSlot.usedadresses) / adressesPerUnit,
                )
              : unitsLeft;

          //const adressesPerUnit = ((mod.totadres! / mod.adresses!) + mod.vrij) / mod.aantal
          const unitsFitByMods =
            MAX_MODS -
            (ctdSlots.find((s) => s.ctdId === targetSlot!.ctdId)?.usedMods ??
              0);

          const unitsFit = Math.min(unitsFitByAddr, unitsFitByMods);
          const unitsToPlace = Math.min(unitsFit, unitsLeft);

          if (unitsToPlace === 0) break;

          targetSlot.usedadresses += unitsToPlace * adressesPerUnit;
          targetSlot.usedMods += unitsToPlace;
          unitsLeft -= unitsToPlace;

          const dist = moduleDistribution.get(mod.modId!)!;
          const existing = dist.find(
            (d: ModDistribution) => d.ctdId === targetSlot!.ctdId,
          );
          if (existing) {
            existing.aantal += unitsToPlace;
            existing.totadres += unitsToPlace * adressesPerUnit;
          } else {
            dist.push({
              ctdId: targetSlot.ctdId,
              aantal: unitsToPlace,
              totadres: unitsToPlace * adressesPerUnit,
            });
          }
        }
      });

      // Update calctd and modules based on distribution
      moduleDistribution.forEach(
        (distList: ModDistribution[], modId: number) => {
          const mod = filtered.find((m) => m.modId === modId);
          if (!mod) return;

          distList.forEach(
            ({ ctdId: targetCtdId, aantal, totadres }: ModDistribution) => {
              const ctdEntry = calctd.get(targetCtdId);
              if (ctdEntry) {
                const shouldCountAsMod =
                  mod.parentModule === 0 || mod.parentModule == null;
                ctdEntry.values.set(
                  "buscons",
                  (ctdEntry.values.get("buscons") ?? 0) +
                    (mod.busCons ?? 0) * aantal,
                );
                ctdEntry.values.set(
                  "adresses",
                  (ctdEntry.values.get("adresses") ?? 0) + totadres,
                );
                ctdEntry.values.set(
                  "mods",
                  (ctdEntry.values.get("mods") ?? 0) +
                    (shouldCountAsMod ? aantal : 0),
                );
              }

              if (targetCtdId !== key) {
                const alreadyExists = modules.mods.find(
                  (m) => m.modId === modId && m.ctdId === targetCtdId,
                );
                if (!alreadyExists) {
                  modules.mods.push({
                    ...mod,
                    ctdId: targetCtdId,
                    aantal,
                    totadres,
                    vrij: 0,
                  });
                } else {
                  modules.mods = modules.mods.map((m) =>
                    m.modId === modId && m.ctdId === targetCtdId
                      ? { ...m, aantal, totadres }
                      : m,
                  );
                }
              }
            },
          );
        },
      );

      // Rebuild original ctd from scratch
      let origBusCons = 0;
      let origadresses = 0;
      let origMods = 0;

      moduleDistribution.forEach(
        (distList: ModDistribution[], modId: number) => {
          const mod = filtered.find((m) => m.modId === modId);
          if (!mod) return;
          const orig = distList.find((d: ModDistribution) => d.ctdId === key);
          // If we have a parentmodule, we should not add this module to modcounter, because it is already counted in the parent module
          
          if (!orig) return;
          origBusCons += (mod.busCons ?? 0) * orig.aantal;
          origadresses += orig.totadres;
          if (mod.parentModule === 0 || mod.parentModule == null) {
            origMods += orig.aantal;
          }
        },
      );

      // Update original ctd modules count
      modules.mods = modules.mods.map((m) => {
        const orig = moduleDistribution
          .get(m.modId!)
          ?.find((d: ModDistribution) => d.ctdId === key);
        if (!orig || m.ctdId !== key) return m;
        return { ...m, aantal: orig.aantal, totadres: orig.totadres };
      });

      calctd.get(key)?.values.set("buscons", origBusCons);
      calctd.get(key)?.values.set("adresses", origadresses);
      calctd.get(key)?.values.set("mods", origMods);
    }
  });

  // calcctd is used in info screen to show how many ctd's are needed for the modules and addresses
  return { modules, updated, calctd };
}

export function GetModById(modId: number) {
  const dbMods: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );

  let retMod: ModuleTypes = {
    id: 0,
    obsolete: 0,
    type: "",
    name: "",
    outputs: 0,
    nextModule: 0,
    parentModule: 0,
    pakket: 0,
    inputs: 0,
    busConsumption: 0,
    adresses: 0,
    sa: 0,
    din: 0,
    icon: "",
    prijs: 0,
    offCat: 0,
    webCat: 0,
  };

  if (dbMods) {
    dbMods.forEach((mod: ModuleTypes) => {
      if (mod.id === modId) {
        retMod = mod;
      }
    });
  }

  return retMod;
}

function checkMod(
  modarray: modsArray2,
  mod: ModuleTypes,
  aantal: number,
  ctdId?: number,
) {
  if (!modarray.mods.some((e) => e.module === mod.name && e.ctdId === ctdId)) {
    let vrij = mod.outputs;
    let aantalMods = 1;
    let totadres = 0;
    if (aantal < mod.outputs) {
      vrij = mod.outputs - aantal;
      aantalMods = 1;
      totadres = aantal * mod.adresses;
    } else {
      const totalMods = Math.ceil(aantal / mod.outputs);
      const overschot = totalMods * mod.outputs - aantal;
      aantalMods = totalMods;
      vrij = overschot;
      totadres = totalMods * mod.outputs * mod.adresses;
    }

    let offerteItem: mods2 = {
      module: mod.name,
      aantal: aantalMods,
      prijs: mod.prijs,
      vrij: vrij,
      modType: mod.type,
      busCons: mod.busConsumption,
      parentModule: mod.parentModule,
      modId: mod.id,
      offCat: mod.offCat,
      adresses: mod.adresses,
      sa: mod.sa,
      pakket: mod.pakket,
      totadres: totadres,
      ctdId: ctdId,
    };
    modarray.mods.push(offerteItem);
  } else {
    modarray.mods.forEach((moda: mods2) => {
      if (moda.module !== mod.name || moda.ctdId !== ctdId) {
        return;
      }
      if (aantal < moda.vrij!) {
        moda.vrij = moda.vrij! - aantal;
      } else {
        const totalMods = moda.aantal! + Math.ceil(aantal / mod.outputs);
        const overschot =
          totalMods * mod.outputs -
          (aantal + moda.aantal! * mod.outputs - moda.vrij!);
        moda.aantal = totalMods;
        moda.vrij = overschot;
      }
    });
  }

  return modarray;
}

function CalculateParentMods(modules: modsArray2) {
  // Enkel voor modules die een parentModule hebben
  // Werkt perfect voor Zigbee, Easywave
  // ToDo gemengde modules
  // DALI kan modules hebben zoals Zigbee en Aesywave, maar ook gewone uitgangen (dimmer)

  // Op dit punt werd de DALIM reeds berekend met Dimmers
  // Todo: DALIM updaten met deze extra uitgangen (a)

  const mods = modules.mods;

  let parent: ModuleTypes = {
    id: 0,
    obsolete: 0,
    type: "",
    name: "",
    outputs: 0,
    nextModule: 0,
    parentModule: 0,
    pakket: 0,
    inputs: 0,
    busConsumption: 0,
    adresses: 0,
    sa: 0,
    din: 0,
    icon: "",
    prijs: 0,
    offCat: 0,
    webCat: 0,
  };

  let retMods: modsArray2 = { mods: [] };

  retMods.mods.pop();

  function checkModExists(id: number, ctdId?: number): mods2 | undefined {
    return mods.find((m: mods2) => m.modId === id && m.ctdId === ctdId);
  }

  function reCalculateParentMod(parent: any, teller: number) {
    // Get max adrescounter
    // console.log("PARENT: ", parent);
    // console.log("teller:", teller);
    const vrijOnParent = parent.vrij;
    const aantalParent = parent.aantal;
    const pModParams = getModById(parent.modId);
    const maxOutputs = pModParams.outputs;

    console.log("Vrij on parent: ", vrijOnParent);

    if (vrijOnParent - teller > 0) {
      console.log("Nog ", vrijOnParent - teller, " over");
      // Todo update parent
      parent.vrij = vrijOnParent - teller;
    } else {
      let aantal =
        teller + (maxOutputs - vrijOnParent) + (aantalParent - 1) * maxOutputs;

      let aantMods = Math.floor(aantal / maxOutputs);
      const overschot = aantal % maxOutputs;

      console.log("over: ", overschot);
      // if over > 0 -> aantal +1
      let vrij = 0;
      if (overschot >> 0) {
        aantMods = aantMods + 1;
        vrij = maxOutputs - overschot;
      } else {
        vrij = 0;
      }
      parent.vrij = vrij;
      parent.aantal = aantMods;
    }

    return parent;
  }

  mods.forEach((m: any) => {
    // Enkel voor DALI SENS
    if (m.parentModule >> 0) {
      // m = QDSEN
      const totadresses = m.aantal * m.adresses;
      // parent = DALIM
      parent = GetModById(m.parentModule); //QDM
      parent.ctdId = m.ctdId;
      // Check if parent exists in mods (only for DALI)
      console.log(parent);
      let existingmod = checkModExists(parent.id, m.ctdId);
      if (existingmod) {
        // We already have a parentMod
        if (m.parentModule) {
          reCalculateParentMod(existingmod, totadresses);
        }
      } else {
        retMods = checkMod(retMods, parent, totadresses, m.ctdId); //QDSENS
      }
    }
  });

  // Add our parent mod to modlist
  if (retMods.mods.length > 0) {
    retMods.mods.forEach((moda: mods2) => {
      //todo check if we already added this mod DALIM
      // If we don't have the module yet (eg DALI) then create one
      mods.push(moda);
    });
  }

  return modules;
}

/*
  This function calculates the total modules needed based on the provided kastenMap and controllers.
  It first flattens the kastenMap into a single map of modules, 
  then iterates through each module to determine the required quantity and associated parameters.
  If the 'full' flag is false, it only includes modules that require a controller (sa === 1).
  Finally, it calculates any necessary parent modules and returns the final list of modules 
  along with any added controllers and their calculated data.
*/
export function CalculateModulesTotal(
  kastenMap: Map<string, Map<string, Map<string, InnerMapValue2>>>,
  full: boolean,
  controllers: dbItem[],
  maxadres: number,
) {
  let offerteItems: mods2 = {
    module: "123",
    aantal: 5,
    prijs: 0,
    vrij: 0,
    modType: "",
    busCons: -1,
    parentModule: 0,
    modId: 0,
    offCat: 0,
    adresses: 0,
    sa: 0,
    pakket: 0,
    totadres: 0,
  };
  let modules: modsArray2 = { mods: [offerteItems] };

  modules.mods.pop();

  let moduleMap2 = new Map<string, InnerMapValue2[]>();

  kastenMap.forEach((kast_value, kast_key) => {
    kast_value.forEach((modG_value, modG_key) => {
      modG_value.forEach((modT_value, modT_key) => {
        //console.log("Adding module ", modT_key);
        //console.log("module kast id ", modT_value.kastId);
        //console.log("kast id ", kast_key);
        //modT_value.kastId = kast_key;

        const existing = moduleMap2.get(modT_key);
        //modT_value.ctdId =
        if (existing) {
          existing.push(modT_value);
        } else {
          moduleMap2.set(modT_key, [modT_value]);
        }
      });
    });
  });

  moduleMap2.forEach((mod_val, mod_key) => {
    mod_val.forEach((value) => {

      // QWI/* modules (QWI/EW, QWI/ZB) are virtual kast-view container modules
      // synthetically generated from COMWE/COMWZ items. They have no DB entry.
      // The actual COMWE/COMWZ items flow through the normal path and appear in
      // the offerte with their real DB parameters.
      if (mod_key.toUpperCase().startsWith("QWI/")) {
        return;
      }

      let modId: any = findModId(mod_key); //extended mods
      let dbMod: any = getModuleParameters(mod_key);

      if (full === false) {
        if (dbMod.sa === 1) {
          modules.mods.push({
            module: mod_key,
            aantal: value.used,
            prijs: dbMod.prijs,
            vrij: value.vrij,
            modType: value.modType,
            busCons: dbMod.busConsumption,
            parentModule: dbMod.parentModule,
            modId: modId.module_id,
            offCat: dbMod.offCat,
            adresses: dbMod.adresses,
            sa: dbMod.sa,
            pakket: dbMod.pakket,
            totadres: value.usedadresses,
            ctdId: value.ctd,
          });
        }
      } else {
        modules.mods.push({
          module: mod_key,
          aantal: value.used,
          prijs: dbMod.prijs,
          vrij: value.vrij,
          modType: value.modType,
          busCons: dbMod.busConsumption,
          parentModule: dbMod.parentModule,
          modId: modId.module_id,
          offCat: dbMod.offCat,
          adresses: dbMod.adresses,
          sa: dbMod.sa,
          pakket: dbMod.pakket,
          totadres: value.usedadresses,
          ctdId: value.ctd,
        });
      }
    });
  });

  const ewm = CalculateParentMods(modules);

  if (full === true) {
    const { modules, updated, calctd } = CalcultateCtd(
      ewm,
      controllers,
      maxadres,
    );
    // calcctd is een Map die controllers en upgraded controllers bevat
    // updated is de toegevoegde controller
    // modules bevatten hier controllers

    return { modules, updated, calctd };
  } else {
    const added_ctd = controllers;
    const modules = ewm;
    return { modules, added_ctd };
  }
}

/*
  This function splits controllers by address limit.
  It iterates through each controller and checks if the total addresses used exceed the specified limit.
  If it does, it sorts the modules by address usage per unit and redistributes them into new controllers 
  until all modules fit within the limit.
  The function ensures that at least one unit of each module remains in the original controller to prevent infinite recursion.  

*/
function splitControllersByadressLimit(
  map: Map<string, Map<string, Map<string, InnerMapValue2>>>,
  limit: number,
): Map<string, Map<string, Map<string, InnerMapValue2>>> {
  const result = new Map(map);

  function getCtdId(key: string): number | null {
    const match = key.match(/ctd(?:IO|MOD)-(\d+)$/);
    return match ? Number(match[1]) : null;
  }

  function splitCtdMap(
    ctdMap: Map<string, Map<string, InnerMapValue2>>,
    isIO: boolean,
    kastKey: string,
  ): void {
    const prefix = isIO ? "ctdIO-" : "ctdMOD-";
    const kastPrefix = isIO ? "kastIO-" : "kastMOD-";
    const kastIdNum = Number(kastKey.match(/\d+$/)![0]);
    

    for (const [ctdKey, modulesMap] of Array.from(ctdMap.entries())) {
      const ctdId = getCtdId(ctdKey);
      if (ctdId === null) continue;

      const totalAddresses = Array.from(modulesMap.values()).reduce(
        (sum, v) => sum + v.usedadresses,
        0,
      );

      // ✅ Skip CTDs already within limit — no split needed
      if (totalAddresses <= limit) continue;
      const sortedEntries = Array.from(modulesMap.entries()).sort(
        ([, a], [, b]) => {
          const unitA = a.used > 0 ? a.usedadresses / a.used : 0;
          const unitB = b.used > 0 ? b.usedadresses / b.used : 0;
          return unitB - unitA;
        },
      );

      let running = 0;
      const keepEntries: [string, InnerMapValue2][] = [];
      const overflowEntries: [string, InnerMapValue2][] = [];

      for (const [modKey, modValue] of sortedEntries) {
        const unitAdress =
          modValue.used > 0 ? modValue.usedadresses / modValue.used : 0;
        const totalUnits = modValue.used;

        let unitsToKeep = 0;
        for (let i = 0; i < totalUnits; i++) {
          if (running + unitAdress <= limit) {
            running += unitAdress;
            unitsToKeep++;
          } else {
            if (running === 0 && unitsToKeep === 0) {
              unitsToKeep = 1;
              running += unitAdress;
            }
            break;
          }
        }

        const unitsToOverflow = totalUnits - unitsToKeep;

        if (unitsToKeep > 0) {
          keepEntries.push([
            modKey,
            {
              ...modValue,
              used: unitsToKeep,
              usedadresses: unitsToKeep * unitAdress,
            },
          ]);
        }

        if (unitsToOverflow > 0) {
          overflowEntries.push([
            modKey,
            {
              ...modValue,
              used: unitsToOverflow,
              usedadresses: unitsToOverflow * unitAdress,
              ctd: ctdId + 100,
            },
          ]);
        }
      }

      // Update current ctd with only kept units
      ctdMap.set(ctdKey, new Map(keepEntries));

      // ✅ Only recurse if there's actual overflow to process
      if (overflowEntries.length === 0) continue;

      const overflowKastKey = `${kastPrefix}${kastIdNum + 100}`;
      const overflowCtdKey = `${prefix}${ctdId + 100}`;

      if (!result.has(overflowKastKey)) {
        result.set(overflowKastKey, new Map());
      }

      const overflowKastMap = result.get(overflowKastKey)!;

      const existingOverflowCtd =
        overflowKastMap.get(overflowCtdKey) ?? new Map();
      for (const [modKey, modValue] of overflowEntries) {
        existingOverflowCtd.set(modKey, modValue);
      }
      overflowKastMap.set(overflowCtdKey, existingOverflowCtd);

      // Recurse — guaranteed to terminate because:
      // 1. overflowEntries is non-empty only when totalAddresses > limit
      // 2. the safety valve ensures at least 1 unit always stays in keepEntries
      //    so the overflow CTD always has fewer units than the original
      splitCtdMap(overflowKastMap, isIO, overflowKastKey);
    }
  }

  for (const [kastKey, ctdMap] of Array.from(result.entries())) {
    const isIO = kastKey.startsWith("kastIO-");
    const isMOD = kastKey.startsWith("kastMOD-");
    if (!isIO && !isMOD) continue;

    splitCtdMap(ctdMap, isIO, kastKey);
  }

  return result;
}

function splitControllersByModulesLimit(
  map: Map<string, Map<string, Map<string, InnerMapValue2>>>,
  limit: number = MAX_MODS,
): Map<string, Map<string, Map<string, InnerMapValue2>>> {
  const result = new Map(map);

  function getCtdId(key: string): number | null {
    const match = key.match(/ctd(?:IO|MOD)-(\d+)$/);
    return match ? Number(match[1]) : null;
  }
  //debugger
  function splitCtdMap(
    ctdMap: Map<string, Map<string, InnerMapValue2>>,
    isIO: boolean,
    kastKey: string,
  ): void {
    const prefix = isIO ? "ctdIO-" : "ctdMOD-";
    const kastPrefix = isIO ? "kastIO-" : "kastMOD-";
    const kastIdNum = Number(kastKey.match(/\d+$/)![0]);
    //debugger

    for (const [ctdKey, modulesMap] of Array.from(ctdMap.entries())) {
      const ctdId = getCtdId(ctdKey);
      if (ctdId === null) continue;

      const totalModules = Array.from(modulesMap.values()).reduce(
        (sum, v) => sum + v.used,
        0,
      );

      // ✅ Skip CTDs already within limit — no split needed
      if (totalModules <= limit) continue;

      const sortedEntries = Array.from(modulesMap.entries()).sort(
        ([, a], [, b]) => {
          const unitA = a.used > 0 ? a.used / a.used : 0;
          const unitB = b.used > 0 ? b.used / b.used : 0;
          return unitB - unitA;
        },
      );

      let running = 0;
      const keepEntries: [string, InnerMapValue2][] = [];
      const overflowEntries: [string, InnerMapValue2][] = [];

      for (const [modKey, modValue] of sortedEntries) {
        const unitAdress = modValue.used > 0 ? modValue.used : 0;
        const totalUnits = modValue.used;

        //let unitsToKeep = 0;
       
const unitsToOverflow =  Math.min(totalUnits, limit);
        const unitsToKeep = totalUnits - unitsToOverflow;

/*
debugger
        for (let i = 0; i < totalUnits; i++) {
          if (running + unitAdress <= limit) {
            running += unitAdress;
            unitsToKeep++;
          } else {
            if (running === 0 && unitsToKeep === 0) {
              unitsToKeep = 1;
              running += unitAdress;
            }
            break;
          }
        }
        // TODO: unitstokeep is altijd 1 !!!
        /*
        for (let i = 0; i < totalUnits; i++) {
          if (running + unitAdress <= limit) {
            running += unitAdress;
            unitsToKeep++;
          } else {
            if (running === 0 && unitsToKeep === 0) {
              unitsToKeep = 1;
              running += unitAdress;
            }
            break;
          }
        }

        const unitsToOverflow = totalUnits - unitsToKeep;
*/
        if (unitsToKeep > 0) {
          keepEntries.push([
            modKey,
            {
              ...modValue,
              used: unitsToKeep,
              // usedadresses: unitsToKeep * unitAdress,
            },
          ]);
        }
        const extraCtdId = ctdId + 100;
        if (unitsToOverflow > 0) {
          overflowEntries.push([
            modKey,
            {
              ...modValue,
              used: unitsToOverflow,
              // usedadresses: unitsToOverflow * unitAdress,
              ctd: ctdId + 100,
            },
          ]);
        }
      }

      // Update current ctd with only kept units
      ctdMap.set(ctdKey, new Map(overflowEntries));

      // ✅ Only recurse if there's actual overflow to process
      if (keepEntries.length === 0) continue;

      const overflowKastKey = `${kastPrefix}${kastIdNum + 100}`;
      const overflowCtdKey = `${prefix}${ctdId + 100}`;

      if (!result.has(overflowKastKey)) {
        result.set(overflowKastKey, new Map());
      }

      const overflowKastMap = result.get(overflowKastKey)!;

      const existingOverflowCtd =
        overflowKastMap.get(overflowCtdKey) ?? new Map();
      for (const [modKey, modValue] of keepEntries) {
        existingOverflowCtd.set(modKey, modValue);
      }
      overflowKastMap.set(overflowCtdKey, existingOverflowCtd);

      // Recurse — guaranteed to terminate because:
      // 1. overflowEntries is non-empty only when totalAddresses > limit
      // 2. the safety valve ensures at least 1 unit always stays in keepEntries
      //    so the overflow CTD always has fewer units than the original
      splitCtdMap(overflowKastMap, isIO, overflowKastKey);
    }
  }

  for (const [kastKey, ctdMap] of Array.from(result.entries())) {
    const isIO = kastKey.startsWith("kastIO-");
    const isMOD = kastKey.startsWith("kastMOD-");

    if (!isIO && !isMOD) continue;

    splitCtdMap(ctdMap, isIO, kastKey);
  }

  return result;
}

export function calculate(
  onlySa: boolean,
  rel04_08: boolean,
  full: boolean,
  db: dbItem[],
  maxadres: number,
) {

  const modulesMap: Map<
    string,
    Map<string, Map<string, InnerMapValue2>>
  > = getModulesFromSavedDb_2(db, onlySa, rel04_08);

  // modulesmap heet dalisen maar geen qdm
  function combineMods(mods: mods2[]): mods2[] {
    const map = new Map<string, mods2>();

    for (const item of mods) {
      if (!map.has(item.module)) {
        map.set(item.module, { ...item });
      } else {
        const existing = map.get(item.module)!;

        existing.aantal += item.aantal;
        existing.vrij += item.vrij;
      }
    }

    return Array.from(map.values());
  }

  function combineModsArray(input: modsArray2): modsArray2 {
    return {
      mods: combineMods(input.mods),
    };
  }

  const controllers = db.filter((item) => item.type === "controller");
  const { modules, updated, calctd } = CalculateModulesTotal(
    modulesMap,
    full,
    controllers,
    maxadres,
  );

  let modulesMap2: Map<
    string,
    Map<string, Map<string, InnerMapValue2>>
  > = new Map();

  let modulesMap3: Map<
    string,
    Map<string, Map<string, InnerMapValue2>>
  > = new Map();

  if (calctd) {
    // Here we split the modulesMap for each ctd
    modulesMap3= splitControllersByadressLimit(modulesMap, maxadres);
    modulesMap2 = splitControllersByModulesLimit(modulesMap3);
  }

  // For offerte we need a combined list of modules, so we combine the modules array
  const combinedModules = combineModsArray(modules);

  const db2 = [
    ...db.filter((item) => item.type !== "controller"),
    ...(updated ?? []),
  ];

  // calctd: is used for infoscreen to show the total adresses and modules per ctd
  // combinedModules: is used for offerte to show the total modules needed
  // modulesMap2: is used for kasten 
  // ToDo - Check in modulesmap why we have EZ/ZB items, but we don't have the parent module 
  // we should have the parent module with the wireless devices as children, but now we have only the children without the parent module,
  // which is a problem for building the kasten


  return { combinedModules, modulesMap2, db2, calctd };
}
